import { createContext } from '@lit/context';

export interface LoadingContext {
  registerElement: (id: string) => void;
  markElementLoaded: (id: string) => void;
  unregisterElement: (id: string) => void;
}

export const loadingStateContext = createContext<LoadingContext>(
  Symbol('loading-state-context'),
);
